module.exports = __webpack_public_path__ + "img/p1.8ef229ea.png";